<template>
    <v-autocomplete
        v-model="selected"
        :items="options"
        :label="dropdownInfo.label"
        item-text="name"
        item-value="id"
        clearable
        :hide-details="dropdownInfo.isHideDetails"
        @change="handleDropDownChange($event)"
    />
</template>

<script>
export default {
    props: {
        dropdownInfo: {
            type: Object,
            required: true
        },
        vModel: [String, Number]
    },
    data() {
        return {
            selected: null,
            myOptions: null,
        };
    },
    computed: {
        options() {
            if (this.dropdownInfo.isApi) {
                return this.myOptions;
            }
            else {
                return this.dropdownInfo.options;
            }
        }
    },
    mounted() {
        this.$nextTick(function() {
            if (this.dropdownInfo.isApi) {
                this.getOptions();
            }
        });
    },
    methods: {
        getOptions() {
            var self = this;
            axios({
                method: "GET",
                url: this.dropdownInfo.getAllApi,
            })
                .then(function (response) {
                    self.myOptions = response.data.result.items;
                });
        },
        handleDropDownChange(e) {
            this.$emit("update:vModel", e);
            this.$emit("handleChanges", e);
        }
    }
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/smallComponents/Form/Dropdown.vue